import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://connect.avopla.com/api',
  headers: {
    'Content-Type': 'application/json',
  },
});




async function registrationApi(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem('token');
       var config = {
           method: 'post',
           url: `/restaurant-registration-request`,
           headers:{
            'Accept': 'application/json', 
            'Content-Type': 'application/json', 
            // 'Authorization': 'Bearer '+AUTH_TOKEN
          },
           data : data
       };
       
     return await apiClient(config)
       .then(function (response) {
         return response;
       })
       .catch(function (error) {
         return error.response
     });
  } catch (err) {
    return err
  }
}
export const Services= { registrationApi}